import { render } from "./UploadResultModal.vue?vue&type=template&id=5c9fab35&scoped=true"
import script from "./UploadResultModal.vue?vue&type=script&lang=js"
export * from "./UploadResultModal.vue?vue&type=script&lang=js"

import "./UploadResultModal.vue?vue&type=style&index=0&id=5c9fab35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9fab35"]])

export default __exports__